import React, { useState, useEffect } from "react";
import { Paper, Typography, Grid } from "@material-ui/core";

const OrderHistory = ({ classes, orders }) => {
  function giveDate(stamp) {
    let d = (new Date(stamp) + "").split(" ");
    d[2] = d[2] + ",";

    return [d[1], d[2], d[3]].join(" ");
  }

  return (
    <>
      <Grid item xs={12}>
        {orders.length > 0 &&
          orders.map((order, index) => (
            <Paper elevation={2} className={classes.paperStyles} key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <Typography variant="body1" color="textPrimary">
                  Order Number: <b>{order.readable_id}</b>
                </Typography>
                <Typography variant="body1" color="textPrimary">
                  Status: <b>{order.status}</b>
                </Typography>
                <Typography variant="body1" color="textPrimary">
                  Order from:<b> {order.restaurant_name}</b>
                </Typography>
              </div>
              <div
                style={{
                  marginBottom: "20px",
                  padding: "20px 10px",
                  border: ".5px solid #909090",
                  borderRadius: "10px",
                }}
              >
                {order.Cart.cartItem.map((item, i) => (
                  <Typography
                    key={i}
                    variant="body1"
                    color="textPrimary"
                  >{`${item.quantity} x ${item.name}`}</Typography>
                ))}
              </div>
              <div>
                <Typography variant="body1" color="textPrimary">
                  Placed On: <b>{giveDate(order?.created_at)}</b>
                </Typography>
              </div>
              <div>
                <Typography variant="body1" color="textPrimary">
                  Total: <b>${order?.Cart?.cart_total}</b>
                </Typography>
              </div>
            </Paper>
          ))}
      </Grid>
    </>
  );
};

export default OrderHistory;
